import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ActivityServices } from '../../../follow-ups/services/activities.services';
import { BaseServices } from '../../../kuba.services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-business-selection-dialog',
  templateUrl: './business-selection-dialog.component.html',
  styleUrls: ['./business-selection-dialog.component.scss'],
  standalone: false
})
export class BusinessSelectionDialogComponent implements OnInit, OnDestroy, OnChanges {
  @Input() visible: boolean = false;
  @Input() title: string = 'SELECT_BUSINESS';
  @Input() description: string = 'SELECT_BUSINESS_FOR_NEW_DEVIATION';
  @Input() confirmButtonText: string = 'CREATE';
  @Input() cancelButtonText: string = 'CANCEL';
  @Input() required: boolean = true;
  @Input() showClear: boolean = true;
  @Input() filter: boolean = true;
  @Input() filterPlaceholder: string = 'SEARCH_BUSINESS';
  @Input() placeholder: string = 'SELECT_BUSINESS';
  @Input() disabled: boolean = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() businessSelected = new EventEmitter<{id: number; name: string}>();
  @Output() cancelled = new EventEmitter<void>();

  availableBusinesses: SelectItem[] = [];
  selectedBusiness: any = null;
  businessLoading: boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(private activityServices: ActivityServices) {}

  ngOnInit(): void {
    // Don't load businesses here - wait for dialog to become visible
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && changes['visible'].currentValue === true) {
      this.loadBusinesses();
    } else if (changes['visible'] && changes['visible'].currentValue === false) {
      this.resetForm();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onVisibleChange(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(visible);
  }

  onBusinessChanged(event: any): void {
    this.selectedBusiness = event.value;
  }

  onConfirm(): void {
    if (this.selectedBusiness) {
      // Find the selected business object to get the name
      const selectedBusinessObj = this.availableBusinesses.find(b => b.value === this.selectedBusiness.value);
      if (selectedBusinessObj) {
        this.businessSelected.emit({
          id: this.selectedBusiness.value,
          name: selectedBusinessObj.label
        });
      }
      this.resetForm();
      this.onVisibleChange(false);
    }
  }

  onCancel(): void {
    this.cancelled.emit();
    this.resetForm();
    this.onVisibleChange(false);
  }

  onDialogHide(): void {
    // When dialog is closed via X button, treat it as cancellation
    this.cancelled.emit();
    this.resetForm();
  }

  private loadBusinesses(): void {
    this.businessLoading = true;
    const portalId = BaseServices.PortalId;

    this.subscriptions.push(
      this.activityServices.getBusinessesForPortalActivities(portalId).subscribe({
        next: (response: any) => {
          const rawBusinesses = Array.isArray(response) ? response : response?.Businesses || [];
          this.availableBusinesses = rawBusinesses.map((business: any) => ({
            label: business.Name,
            value: business.BusinessId
          }));
          this.businessLoading = false;
        },
        error: (error: any) => {
          console.error('Error loading businesses for portal:', error);
          this.businessLoading = false;
        }
      })
    );
  }

  private resetForm(): void {
    this.selectedBusiness = null;
    this.availableBusinesses = [];
  }

  get isConfirmDisabled(): boolean {
    return this.businessLoading || (this.required && !this.selectedBusiness);
  }
}
